/**
 * @generated SignedSource<<771e8a79430b14aa167a8c0a4acdfa46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpModalFragment$data = {
  readonly organizations: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly slug: string;
    }>;
  };
  readonly " $fragmentType": "helpModalFragment";
};
export type helpModalFragment$key = {
  readonly " $data"?: helpModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpModalFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "helpModalFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationConnection",
      "kind": "LinkedField",
      "name": "organizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0994f31aec70fbbc04e336e93c400fa9";

export default node;
